import { match } from 'ts-pattern'

const localeText = {
    noRowsLabel: 'Nenhum resultado',
    // Density selector toolbar button text
    toolbarDensity: 'Densidade',
    toolbarDensityCompact: 'Compacto',
    toolbarDensityStandard: 'Padrão',
    toolbarDensityComfortable: 'Confortável',

    // Columns selector toolbar button text
    toolbarColumns: 'Colunas',

    // Filters toolbar button text
    toolbarFilters: 'Filtros',

    // Export selector toolbar button text
    toolbarExport: 'Exportar',
    toolbarExportCSV: 'Exportar CSV',
    toolbarExportTXT: 'Exportar TXT',
    toolbarExportPrint: 'Imprimir',

    // Columns panel text
    columnsPanelTextFieldLabel: 'Encontrar coluna',
    columnsPanelShowAllButton: 'Exibir',
    columnsPanelHideAllButton: 'Esconder',
    columnsPanelResetButton: 'Redefinir padrão',

    // Filter panel text
    filterPanelAddFilter: 'Adicionar',
    filterPanelDeleteIconLabel: 'Remover',
    filterPanelOperatorAnd: 'E',
    filterPanelOperatorOr: 'OU',
    filterPanelColumn: 'Coluna',
    filterPanelOperator: 'Operador',
    filterPanelValue: 'Valor',
    filterPanelInputPlaceholder: 'Filtrar por',
    filterPanelValueYes: 'Sim',
    filterPanelValueNo: 'Não',

    cellValueTrue: 'Sim',
    cellValueFalse: 'Não',

    // Filter operators text
    filterOperatorContains: 'contém',
    filterOperatorEquals: 'igual',
    filterOperatorStartsWith: 'inicia com',
    filterOperatorEndsWith: 'termina com',
    filterOperatorIs: 'é',
    filterOperatorNot: 'não é',
    filterOperatorAfter: 'está depois',
    filterOperatorOnOrAfter: 'contém ou depois',
    filterOperatorBefore: 'está antes',
    filterOperatorOnOrBefore: 'contém ou está antes',
    filterOperatorIsEmpty: 'está vazio',
    filterOperatorIsNotEmpty: 'não está vazio',

    // Column menu text
    columnMenuUnsort: 'Não ordenar',
    columnMenuSortAsc: 'Ordenar A-Z',
    columnMenuSortDesc: 'Ordenar Z-A',

    // Column header text
    columnHeaderSortIconLabel: 'Ordenar',

    // Rows selected footer text
    footerRowSelected: (count: number) =>
        match(count)
            .with(0, () => '')
            .with(1, () => `${count.toLocaleString()} linha selecionada`)
            .otherwise(() => `${count.toLocaleString()} linhas selecionadas`),
    footerShowingRows: (from: number, to: number, count: number) => {
        if (count === 0) return ['']
        return [
            'Exibindo ',
            `${from.toLocaleString()} - ${to.toLocaleString()} de ${count.toLocaleString()}`,
        ]
    },
    footerRowsPerPage: 'Linhas por página ',
    footerAllRows: 'Todas',

    paginationLabelPageXofY: ({
        index,
        pages,
    }: {
        index: number
        pages: number
    }) => ['Página ', `${index.toLocaleString()} de ${pages.toLocaleString()}`],
    toolbarQuickFilterPlaceholder: 'Pesquisar...',
    next: 'Próximo',
    previous: 'Anterior',
}

export default localeText
